import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { IonItem } from '@ionic/vue';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'trust-bar',
  props: {
    maxTrust: null,
    reportTrust: null
  },
  setup(__props: any) {

const props = __props as {
    maxTrust: number,
    reportTrust: number
};



const trustLevel = computed(()=>{
    return props.reportTrust/props.maxTrust*100;
}) 

return (_ctx: any,_cache: any) => {
  return (__props.reportTrust && __props.maxTrust)
    ? (_openBlock(), _createBlock(_unref(IonItem), {
        key: 0,
        color: "medium",
        class: "ion-no-padding customButton",
        style: {"--inner-padding-end":"0","height":"24px","align-items":"first baseline"}
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonItem), {
            id: "trust",
            class: "ion-no-padding",
            color: _unref(trustLevel)>=75 ? 'success': _unref(trustLevel)>=25 ? 'warning' : 'danger',
            style: _normalizeStyle('width:' + __props.reportTrust/__props.maxTrust*100 + '%; height: 24px; border-radius: 12px;')
          }, null, 8, ["color", "style"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})